import React from "react";
import './servicescard.css';

const ServicesCard = ({ heading, subheading, icon }) => {
    return (
        <div className="service-container">
            <div className="service-icon">
                {icon}
            </div>
            <div className="service-heading t5 font-semibold">
                {heading}
            </div>
            <div className="service-heading t6 font-medium">
                {subheading}
            </div>
        </div>
    )
};

export default ServicesCard;